import {LogLevel} from './log-level';

export abstract class LogLevelAwareConfig {
  /**
   * Log Message Level that triggers processing.
   */
  triggerLevel: LogLevel = LogLevel.Debug;

  /**
   * Number of previous log messages processed as context.
   */
  contextSize: number = 0;
}
